<template>
  <v-main class="fill-height d-flex align-center">
    <v-row justify="center">
      <v-col cols="4">
        <v-form @submit.prevent="login">
          <v-card>
            <v-card-title>
              Login
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field outlined hide-details label="Username" v-model="username"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-text-field outlined hide-details label="Password" type="password" v-model="password"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" block type="submit">Login</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-main>
</template>

<script>
export default {
  name: "LoginPage",
  data() {
    return {
      username: "",
      password: ""
    }
  },
  methods: {
    login() {
      this.$axios.post("/api/login", {
        "username": this.username,
        "password": this.password
      }).then(res => {
        const data = res.data;

        if (data.success) {
          // store authentiation
          this.$store.commit("authenticate", data.user);

          // reconnect to load with full auth
          location.reload();
        } else {
          this.password = "";
        }
      }).catch(() => {
        this.password = "";
      });
    }
  }
}
</script>

<style scoped>

</style>
